"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOpeningImages = exports.mapOpenings = exports.getOpeningInputs = exports.getOpeningInput = exports.getFeaturesAndInputList = exports.mapInputs = exports.getInputsList = exports.getInputs = exports.getInput = void 0;
function getInput(file, featureId, type) {
    const featureInput = file.inputs[featureId];
    if ((featureInput === null || featureInput === void 0 ? void 0 : featureInput.type) === type) {
        return featureInput;
    }
    else {
        return null;
    }
}
exports.getInput = getInput;
function getInputs(file, type) {
    return Object.entries(file.inputs)
        .filter(([_, input]) => input.type === type)
        .reduce((inputs, [featureId, featureInput]) => {
        inputs[featureId] = featureInput;
        return inputs;
    }, {});
}
exports.getInputs = getInputs;
function getInputsList(file, type) {
    return Object.values(file.inputs)
        .filter((input) => input.type === type)
        .map((input) => input);
}
exports.getInputsList = getInputsList;
function mapInputs(file, type, mapper, allowDeletion) {
    return Object.assign(Object.assign({}, file), { inputs: Object.fromEntries(Object.entries(file.inputs)
            .map(([featureId, featureInput]) => {
            if (featureInput.type === type) {
                const result = mapper(featureInput, featureId);
                if (!result && allowDeletion === "ALLOW_DELETION") {
                    return undefined;
                }
                return [featureId, result];
            }
            return [featureId, featureInput];
        })
            .filter((x) => !!x)) });
}
exports.mapInputs = mapInputs;
/**
 * Convenience method to return a feature and it's input at the same time.
 */
function getFeaturesAndInputList(design, file, type, filter) {
    return Object.entries(design.features)
        .filter(([featureId, feature]) => {
        if (feature.type !== type) {
            return false;
        }
        if (filter) {
            return filter(feature, file.inputs[featureId]);
        }
        else {
            return true;
        }
    })
        .map(([featureId, feature]) => {
        return {
            featureId,
            feature,
            input: file.inputs[featureId],
        };
    });
}
exports.getFeaturesAndInputList = getFeaturesAndInputList;
function getOpeningInput(file, id) {
    return getInput(file, id, "OPENING");
}
exports.getOpeningInput = getOpeningInput;
function getOpeningInputs(file) {
    return getInputsList(file, "OPENING");
}
exports.getOpeningInputs = getOpeningInputs;
function mapOpenings(file, mapper, allowDeletions) {
    return mapInputs(file, "OPENING", mapper, allowDeletions);
}
exports.mapOpenings = mapOpenings;
function mapOpeningImages(file, mapper, allowDeletions) {
    return mapInputs(file, "OPENING", (openingInput, openingId) => {
        const images = openingInput.images
            .map((imageInput) => mapper(imageInput, openingInput, openingId))
            .filter((x) => !!x);
        if (allowDeletions === "ALLOW_DELETION" && !shouldBeSaved(openingInput)) {
            return undefined;
        }
        return Object.assign(Object.assign({}, openingInput), { images });
    }, allowDeletions);
}
exports.mapOpeningImages = mapOpeningImages;
/**
 * Whether the given opening input has choices made by the user that should be saved.
 */
function shouldBeSaved(openingInput) {
    return (openingInput.images.length > 0 ||
        openingInput.enabled === true ||
        !!openingInput.background);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJGaWxlVXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvTWFwbWFrZXJGaWxlVXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBU0EsU0FBZ0IsUUFBUSxDQUN0QixJQUFrQyxFQUNsQyxTQUFpQixFQUNqQixJQUFlO0lBRWYsTUFBTSxZQUFZLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUM1QyxJQUFJLENBQUEsWUFBWSxhQUFaLFlBQVksdUJBQVosWUFBWSxDQUFFLElBQUksTUFBSyxJQUFJLEVBQUU7UUFDL0IsT0FBTyxZQUFpQixDQUFDO0tBQzFCO1NBQU07UUFDTCxPQUFPLElBQUksQ0FBQztLQUNiO0FBQ0gsQ0FBQztBQVhELDRCQVdDO0FBRUQsU0FBZ0IsU0FBUyxDQUN2QixJQUFrQyxFQUNsQyxJQUFpQjtJQUVqQixPQUFPLE1BQU0sQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztTQUMvQixNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLENBQUMsRUFBRSxFQUFFLENBQUMsS0FBSyxDQUFDLElBQUksS0FBSyxJQUFJLENBQUM7U0FDM0MsTUFBTSxDQUFDLENBQUMsTUFBTSxFQUFFLENBQUMsU0FBUyxFQUFFLFlBQVksQ0FBQyxFQUFFLEVBQUU7UUFDNUMsTUFBTSxDQUFDLFNBQVMsQ0FBQyxHQUFHLFlBQVksQ0FBQztRQUNqQyxPQUFPLE1BQU0sQ0FBQztJQUNoQixDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFDWCxDQUFDO0FBVkQsOEJBVUM7QUFFRCxTQUFnQixhQUFhLENBQzNCLElBQWtDLEVBQ2xDLElBQWU7SUFFZixPQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztTQUM5QixNQUFNLENBQUMsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDO1NBQ3RDLEdBQUcsQ0FBSSxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsS0FBcUIsQ0FBQyxDQUFDO0FBQzlDLENBQUM7QUFQRCxzQ0FPQztBQUVELFNBQWdCLFNBQVMsQ0FJdkIsSUFBTyxFQUNQLElBQWUsRUFDZixNQUFpRCxFQUNqRCxhQUFnQztJQUVoQyx1Q0FDSyxJQUFJLEtBQ1AsTUFBTSxFQUFFLE1BQU0sQ0FBQyxXQUFXLENBQ3hCLE1BQU0sQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQzthQUN4QixHQUFHLENBQUMsQ0FBQyxDQUFDLFNBQVMsRUFBRSxZQUFZLENBQUMsRUFBRSxFQUFFO1lBQ2pDLElBQUksWUFBWSxDQUFDLElBQUksS0FBSyxJQUFJLEVBQUU7Z0JBQzlCLE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxZQUFpQixFQUFFLFNBQVMsQ0FBQyxDQUFDO2dCQUNwRCxJQUFJLENBQUMsTUFBTSxJQUFJLGFBQWEsS0FBSyxnQkFBZ0IsRUFBRTtvQkFDakQsT0FBTyxTQUFTLENBQUM7aUJBQ2xCO2dCQUNELE9BQU8sQ0FBQyxTQUFTLEVBQUUsTUFBTSxDQUFDLENBQUM7YUFDNUI7WUFDRCxPQUFPLENBQUMsU0FBUyxFQUFFLFlBQVksQ0FBQyxDQUFDO1FBQ25DLENBQUMsQ0FBQzthQUNELE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUN0QixJQUNEO0FBQ0osQ0FBQztBQTFCRCw4QkEwQkM7QUFnQkQ7O0dBRUc7QUFDSCxTQUFnQix1QkFBdUIsQ0FJckMsTUFBd0MsRUFDeEMsSUFBa0MsRUFDbEMsSUFBaUIsRUFDakIsTUFBb0M7SUFFcEMsT0FBTyxNQUFNLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUM7U0FDbkMsTUFBTSxDQUFDLENBQUMsQ0FBQyxTQUFTLEVBQUUsT0FBTyxDQUFDLEVBQUUsRUFBRTtRQUMvQixJQUFJLE9BQU8sQ0FBQyxJQUFJLEtBQUssSUFBSSxFQUFFO1lBQ3pCLE9BQU8sS0FBSyxDQUFDO1NBQ2Q7UUFDRCxJQUFJLE1BQU0sRUFBRTtZQUNWLE9BQU8sTUFBTSxDQUFDLE9BQVksRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDLFNBQVMsQ0FBTSxDQUFDLENBQUM7U0FDMUQ7YUFBTTtZQUNMLE9BQU8sSUFBSSxDQUFDO1NBQ2I7SUFDSCxDQUFDLENBQUM7U0FDRCxHQUFHLENBQXdCLENBQUMsQ0FBQyxTQUFTLEVBQUUsT0FBTyxDQUFDLEVBQUUsRUFBRTtRQUNuRCxPQUFPO1lBQ0wsU0FBUztZQUNULE9BQU87WUFDUCxLQUFLLEVBQUUsSUFBSSxDQUFDLE1BQU0sQ0FBQyxTQUFTLENBQUM7U0FDTCxDQUFDO0lBQzdCLENBQUMsQ0FBQyxDQUFDO0FBQ1AsQ0FBQztBQTNCRCwwREEyQkM7QUFFRCxTQUFnQixlQUFlLENBQzdCLElBQWtDLEVBQ2xDLEVBQVU7SUFFVixPQUFPLFFBQVEsQ0FBZSxJQUFJLEVBQUUsRUFBRSxFQUFFLFNBQVMsQ0FBQyxDQUFDO0FBQ3JELENBQUM7QUFMRCwwQ0FLQztBQUVELFNBQWdCLGdCQUFnQixDQUM5QixJQUFrQztJQUVsQyxPQUFPLGFBQWEsQ0FBZSxJQUFJLEVBQUUsU0FBUyxDQUFDLENBQUM7QUFDdEQsQ0FBQztBQUpELDRDQUlDO0FBRUQsU0FBZ0IsV0FBVyxDQUN6QixJQUFPLEVBQ1AsTUFBdUUsRUFDdkUsY0FBaUM7SUFFakMsT0FBTyxTQUFTLENBQUMsSUFBSSxFQUFFLFNBQVMsRUFBRSxNQUFNLEVBQUUsY0FBYyxDQUFDLENBQUM7QUFDNUQsQ0FBQztBQU5ELGtDQU1DO0FBRUQsU0FBZ0IsZ0JBQWdCLENBQzlCLElBQU8sRUFDUCxNQUlzQixFQUN0QixjQUFpQztJQUVqQyxPQUFPLFNBQVMsQ0FDZCxJQUFJLEVBQ0osU0FBUyxFQUNULENBQUMsWUFBMEIsRUFBRSxTQUFpQixFQUFFLEVBQUU7UUFDaEQsTUFBTSxNQUFNLEdBQUcsWUFBWSxDQUFDLE1BQU07YUFDL0IsR0FBRyxDQUFDLENBQUMsVUFBVSxFQUFFLEVBQUUsQ0FBQyxNQUFNLENBQUMsVUFBVSxFQUFFLFlBQVksRUFBRSxTQUFTLENBQUMsQ0FBQzthQUNoRSxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN0QixJQUFJLGNBQWMsS0FBSyxnQkFBZ0IsSUFBSSxDQUFDLGFBQWEsQ0FBQyxZQUFZLENBQUMsRUFBRTtZQUN2RSxPQUFPLFNBQVMsQ0FBQztTQUNsQjtRQUNELHVDQUNLLFlBQVksS0FDZixNQUFNLElBQ047SUFDSixDQUFDLEVBQ0QsY0FBYyxDQUNmLENBQUM7QUFDSixDQUFDO0FBMUJELDRDQTBCQztBQUVEOztHQUVHO0FBQ0gsU0FBUyxhQUFhLENBQUMsWUFBMEI7SUFDL0MsT0FBTyxDQUNMLFlBQVksQ0FBQyxNQUFNLENBQUMsTUFBTSxHQUFHLENBQUM7UUFDOUIsWUFBWSxDQUFDLE9BQU8sS0FBSyxJQUFJO1FBQzdCLENBQUMsQ0FBQyxZQUFZLENBQUMsVUFBVSxDQUMxQixDQUFDO0FBQ0osQ0FBQyJ9